module.exports = __webpack_public_path__ + "static/media/undraw_publish_article_re_3x8h.6785f764.svg";